<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9.003 5.588a3.412 3.412 0 0 1 3.411 3.41c0 .444-.089.86-.245 1.25l1.991 1.991a8.061 8.061 0 0 0 2.34-3.24c-1.18-2.995-4.093-5.116-7.503-5.116-.955 0-1.87.17-2.715.477l1.473 1.474a3.31 3.31 0 0 1 1.248-.246Zm-6.82-1.862 1.554 1.555.314.314A8.052 8.052 0 0 0 1.5 9c1.18 2.994 4.093 5.116 7.503 5.116a8.033 8.033 0 0 0 2.988-.573l.287.286 1.998 1.992.867-.866L3.048 2.86l-.866.866Zm3.771 3.772 1.058 1.058a1.924 1.924 0 0 0-.055.443c0 1.132.914 2.046 2.046 2.046.15 0 .3-.02.444-.054l1.057 1.057a3.381 3.381 0 0 1-1.5.361A3.412 3.412 0 0 1 5.592 9c0-.539.136-1.044.361-1.5Zm2.94-.532 2.149 2.149.014-.11A2.044 2.044 0 0 0 9.01 6.96l-.116.007Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
